// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"809":"9a0f0bd37d6ddd84","6362":"ec49c1c973fda511","9384":"cb4d24872cb71bb5"}[chunkId] + ".js";
};